export const DELIVERY_DAY_SUNDAY = 	1n;
export const DELIVERY_DAY_MONDAY = 	1n << 1n;
export const DELIVERY_DAY_TUESDAY = 1n << 2n;
export const DELIVERY_DAY_WEDNESDAY = 1n << 3n;
export const DELIVERY_DAY_THURSDAY = 1n << 4n;
export const DELIVERY_DAY_FRIDAY = 1n << 5n;
export const DELIVERY_DAY_SATURDAY = 1n << 6n;
export const DELIVERY_DAY_1 = 1n << 7n;
export const DELIVERY_DAY_2 = 1n << 8n;
export const DELIVERY_DAY_3 = 1n << 9n;
export const DELIVERY_DAY_4 = 1n << 10n;
export const DELIVERY_DAY_5 = 1n << 11n;
export const DELIVERY_DAY_6 = 1n << 12n;
export const DELIVERY_DAY_7 = 1n << 13n;
export const DELIVERY_DAY_8 = 1n << 14n;
export const DELIVERY_DAY_9 = 1n << 15n;
export const DELIVERY_DAY_10 = 1n << 16n;
export const DELIVERY_DAY_11 = 1n << 17n;
export const DELIVERY_DAY_12 = 1n << 18n;
export const DELIVERY_DAY_13 = 1n << 19n;
export const DELIVERY_DAY_14 = 1n << 20n;
export const DELIVERY_DAY_15 = 1n << 21n;
export const DELIVERY_DAY_16 = 1n << 22n;
export const DELIVERY_DAY_17 = 1n << 23n;
export const DELIVERY_DAY_18 = 1n << 24n;
export const DELIVERY_DAY_19 = 1n << 25n;
export const DELIVERY_DAY_20 = 1n << 26n;
export const DELIVERY_DAY_21 = 1n << 27n;
export const DELIVERY_DAY_22 = 1n << 28n;
export const DELIVERY_DAY_23 = 1n << 29n;
export const DELIVERY_DAY_24 = 1n << 30n;
export const DELIVERY_DAY_25 = 1n << 31n;
export const DELIVERY_DAY_26 = 1n << 32n;
export const DELIVERY_DAY_27 = 1n << 33n;
export const DELIVERY_DAY_28 = 1n << 34n;
export const DELIVERY_DAY_29 = 1n << 35n;
export const DELIVERY_DAY_30 = 1n << 36n;
export const DELIVERY_DAY_31 = 1n << 37n;
export const DELIVERY_DAY_32 = 1n << 38n;
export const DELIVERY_DAY_33 = 1n << 39n;
export const DELIVERY_DAY_34 = 1n << 40n;
export const DELIVERY_DAY_35 = 1n << 41n;
export const DELIVERY_DAY_36 = 1n << 42n;
export const DELIVERY_DAY_37 = 1n << 43n;
export const DELIVERY_DAY_38 = 1n << 44n;
export const DELIVERY_DAY_39 = 1n << 45n;
export const DELIVERY_DAY_40 = 1n << 46n;
export const DELIVERY_DAY_41 = 1n << 47n;
export const DELIVERY_DAY_42 = 1n << 48n;
export const DELIVERY_DAY_43 = 1n << 49n;
export const DELIVERY_DAY_44 = 1n << 50n;
export const DELIVERY_DAY_45 = 1n << 51n;
export const DELIVERY_DAY_46 = 1n << 52n;
export const DELIVERY_DAY_47 = 1n << 53n;
export const DELIVERY_DAY_48 = 1n << 54n;
export const DELIVERY_DAY_49 = 1n << 55n;

const _value = Symbol();

export class PatientProgressDeliveryDays {
	constructor(value) {
		this.value = value;
	}
	get value() {
		return this[_value];
	}
	set value(v) {
		if(typeof v !== 'bigint')
			throw new TypeError('value must be a bigint.');
		this[_value] = v;
	}
	get sunday() {
		return this.value & DELIVERY_DAY_SUNDAY ? true : false;
	}
	set sunday(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_SUNDAY : this.value & ~DELIVERY_DAY_SUNDAY;
	}
	get monday() {
		return this.value & DELIVERY_DAY_MONDAY ? true : false;
	}
	set monday(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_MONDAY : this.value & ~DELIVERY_DAY_MONDAY;
	}
	get tuesday() {
		return this.value & DELIVERY_DAY_TUESDAY ? true : false;
	}
	set tuesday(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_TUESDAY : this.value & ~DELIVERY_DAY_TUESDAY;
	}
	get wednesday() {
		return this.value & DELIVERY_DAY_WEDNESDAY ? true : false;
	}
	set wednesday(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_WEDNESDAY : this.value & ~DELIVERY_DAY_WEDNESDAY;
	}
	get thursday() {
		return this.value & DELIVERY_DAY_THURSDAY ? true : false;
	}
	set thursday(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_THURSDAY : this.value & ~DELIVERY_DAY_THURSDAY;
	}
	get friday() {
		return this.value & DELIVERY_DAY_FRIDAY ? true : false;
	}
	set friday(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_FRIDAY : this.value & ~DELIVERY_DAY_FRIDAY;
	}
	get saturday() {
		return this.value & DELIVERY_DAY_SATURDAY ? true : false;
	}
	set saturday(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_SATURDAY : this.value & ~DELIVERY_DAY_SATURDAY;
	}
	get day1() {
		return this.value & DELIVERY_DAY_1 ? true : false;
	}
	set day1(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_1 : this.value & ~DELIVERY_DAY_1;
	}
	get day2() {
		return this.value & DELIVERY_DAY_2 ? true : false;
	}
	set day2(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_2 : this.value & ~DELIVERY_DAY_2;
	}
	get day3() {
		return this.value & DELIVERY_DAY_3 ? true : false;
	}
	set day3(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_3 : this.value & ~DELIVERY_DAY_3;
	}
	get day4() {
		return this.value & DELIVERY_DAY_4 ? true : false;
	}
	set day4(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_4 : this.value & ~DELIVERY_DAY_4;
	}
	get day5() {
		return this.value & DELIVERY_DAY_5 ? true : false;
	}
	set day5(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_5 : this.value & ~DELIVERY_DAY_5;
	}
	get day6() {
		return this.value & DELIVERY_DAY_6 ? true : false;
	}
	set day6(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_6 : this.value & ~DELIVERY_DAY_6;
	}
	get day7() {
		return this.value & DELIVERY_DAY_7 ? true : false;
	}
	set day7(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_7 : this.value & ~DELIVERY_DAY_7;
	}
	get day8() {
		return this.value & DELIVERY_DAY_8 ? true : false;
	}
	set day8(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_8 : this.value & ~DELIVERY_DAY_8;
	}
	get day9() {
		return this.value & DELIVERY_DAY_9 ? true : false;
	}
	set day9(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_9 : this.value & ~DELIVERY_DAY_9;
	}
	get day10() {
		return this.value & DELIVERY_DAY_10 ? true : false;
	}
	set day10(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_10 : this.value & ~DELIVERY_DAY_10;
	}
	get day11() {
		return this.value & DELIVERY_DAY_11 ? true : false;
	}
	set day11(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_11 : this.value & ~DELIVERY_DAY_11;
	}
	get day12() {
		return this.value & DELIVERY_DAY_12 ? true : false;
	}
	set day12(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_12 : this.value & ~DELIVERY_DAY_12;
	}
	get day13() {
		return this.value & DELIVERY_DAY_13 ? true : false;
	}
	set day13(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_13 : this.value & ~DELIVERY_DAY_13;
	}
	get day14() {
		return this.value & DELIVERY_DAY_14 ? true : false;
	}
	set day14(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_14 : this.value & ~DELIVERY_DAY_14;
	}
	get day15() {
		return this.value & DELIVERY_DAY_15 ? true : false;
	}
	set day15(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_15 : this.value & ~DELIVERY_DAY_15;
	}
	get day16() {
		return this.value & DELIVERY_DAY_16 ? true : false;
	}
	set day16(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_16 : this.value & ~DELIVERY_DAY_16;
	}
	get day17() {
		return this.value & DELIVERY_DAY_17 ? true : false;
	}
	set day17(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_17 : this.value & ~DELIVERY_DAY_17;
	}
	get day18() {
		return this.value & DELIVERY_DAY_18 ? true : false;
	}
	set day18(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_18 : this.value & ~DELIVERY_DAY_18;
	}
	get day19() {
		return this.value & DELIVERY_DAY_19 ? true : false;
	}
	set day19(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_19 : this.value & ~DELIVERY_DAY_19;
	}
	get day20() {
		return this.value & DELIVERY_DAY_20 ? true : false;
	}
	set day20(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_20 : this.value & ~DELIVERY_DAY_20;
	}
	get day21() {
		return this.value & DELIVERY_DAY_21 ? true : false;
	}
	set day21(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_21 : this.value & ~DELIVERY_DAY_21;
	}
	get day22() {
		return this.value & DELIVERY_DAY_22 ? true : false;
	}
	set day22(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_22 : this.value & ~DELIVERY_DAY_22;
	}
	get day23() {
		return this.value & DELIVERY_DAY_23 ? true : false;
	}
	set day23(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_23 : this.value & ~DELIVERY_DAY_23;
	}
	get day24() {
		return this.value & DELIVERY_DAY_24 ? true : false;
	}
	set day24(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_24 : this.value & ~DELIVERY_DAY_24;
	}
	get day25() {
		return this.value & DELIVERY_DAY_25 ? true : false;
	}
	set day25(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_25 : this.value & ~DELIVERY_DAY_25;
	}
	get day26() {
		return this.value & DELIVERY_DAY_26 ? true : false;
	}
	set day26(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_26 : this.value & ~DELIVERY_DAY_26;
	}
	get day27() {
		return this.value & DELIVERY_DAY_27 ? true : false;
	}
	set day27(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_27 : this.value & ~DELIVERY_DAY_27;
	}
	get day28() {
		return this.value & DELIVERY_DAY_28 ? true : false;
	}
	set day28(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_28 : this.value & ~DELIVERY_DAY_28;
	}
	get day29() {
		return this.value & DELIVERY_DAY_29 ? true : false;
	}
	set day29(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_29 : this.value & ~DELIVERY_DAY_29;
	}
	get day30() {
		return this.value & DELIVERY_DAY_30 ? true : false;
	}
	set day30(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_30 : this.value & ~DELIVERY_DAY_30;
	}
	get day31() {
		return this.value & DELIVERY_DAY_31 ? true : false;
	}
	set day31(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_31 : this.value & ~DELIVERY_DAY_31;
	}
	get day32() {
		return this.value & DELIVERY_DAY_32 ? true : false;
	}
	set day32(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_32 : this.value & ~DELIVERY_DAY_32;
	}
	get day33() {
		return this.value & DELIVERY_DAY_33 ? true : false;
	}
	set day33(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_33 : this.value & ~DELIVERY_DAY_33;
	}
	get day34() {
		return this.value & DELIVERY_DAY_34 ? true : false;
	}
	set day34(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_34 : this.value & ~DELIVERY_DAY_34;
	}
	get day35() {
		return this.value & DELIVERY_DAY_35 ? true : false;
	}
	set day35(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_35 : this.value & ~DELIVERY_DAY_35;
	}
	get day36() {
		return this.value & DELIVERY_DAY_36 ? true : false;
	}
	set day36(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_36 : this.value & ~DELIVERY_DAY_36;
	}
	get day37() {
		return this.value & DELIVERY_DAY_37 ? true : false;
	}
	set day37(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_37 : this.value & ~DELIVERY_DAY_37;
	}
	get day38() {
		return this.value & DELIVERY_DAY_38 ? true : false;
	}
	set day38(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_38 : this.value & ~DELIVERY_DAY_38;
	}
	get day39() {
		return this.value & DELIVERY_DAY_39 ? true : false;
	}
	set day39(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_39 : this.value & ~DELIVERY_DAY_39;
	}
	get day40() {
		return this.value & DELIVERY_DAY_40 ? true : false;
	}
	set day40(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_40 : this.value & ~DELIVERY_DAY_40;
	}
	get day41() {
		return this.value & DELIVERY_DAY_41 ? true : false;
	}
	set day41(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_41 : this.value & ~DELIVERY_DAY_41;
	}
	get day42() {
		return this.value & DELIVERY_DAY_42 ? true : false;
	}
	set day42(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_42 : this.value & ~DELIVERY_DAY_42;
	}
	get day43() {
		return this.value & DELIVERY_DAY_43 ? true : false;
	}
	set day43(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_43 : this.value & ~DELIVERY_DAY_43;
	}
	get day44() {
		return this.value & DELIVERY_DAY_44 ? true : false;
	}
	set day44(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_44 : this.value & ~DELIVERY_DAY_44;
	}
	get day45() {
		return this.value & DELIVERY_DAY_45 ? true : false;
	}
	set day45(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_45 : this.value & ~DELIVERY_DAY_45;
	}
	get day46() {
		return this.value & DELIVERY_DAY_46 ? true : false;
	}
	set day46(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_46 : this.value & ~DELIVERY_DAY_46;
	}
	get day47() {
		return this.value & DELIVERY_DAY_47 ? true : false;
	}
	set day47(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_47 : this.value & ~DELIVERY_DAY_47;
	}
	get day48() {
		return this.value & DELIVERY_DAY_48 ? true : false;
	}
	set day48(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_48 : this.value & ~DELIVERY_DAY_48;
	}
	get day49() {
		return this.value & DELIVERY_DAY_49 ? true : false;
	}
	set day49(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('value must be a boolean.');
		this.value = v ? this.value | DELIVERY_DAY_49 : this.value & ~DELIVERY_DAY_49;
	}
	toJSON() {
		return this.value.toString();
	}
	static fromString(v) {
		if(typeof v !== 'string')
			throw new TypeError('value must be a string.');
		if(!/^[0-9]+$/.test(v))
			throw new TypeError('value must only contain characters 0 through 9');
		return new this(BigInt(v));
	}
}